import { Routes, Route, Navigate } from "react-router";
import { Layout } from "./components/Layout.tsx";
import { useAuth } from "./lib/auth.tsx";
import { LoginPage } from "./pages/Login.tsx";
import { SignUpPage } from "./pages/SignUp.tsx";
import { ConfirmSignUpPage } from "./pages/ConfirmSignUp.tsx";
import { NoTenantPage } from "./pages/NoTenant.tsx";
import { OnboardingPage } from "./pages/Onboarding.tsx";
import { DashboardPage } from "./pages/Dashboard.tsx";
import { PackagesPage } from "./pages/Packages.tsx";
import { RoutersPage } from "./pages/Routers.tsx";
import { VouchersPage } from "./pages/Vouchers.tsx";
import { SettingsPage } from "./pages/Settings.tsx";

function RequireTenant({ children }: { children: React.ReactNode }) {
  const { isLoading, isAuthenticated, tenant, needsTenantAssignment } = useAuth();
  if (isLoading) {
    return (
      <div className="grid min-h-screen place-items-center text-sm text-slate-500">
        Loading…
      </div>
    );
  }
  if (!isAuthenticated) return <Navigate to="/login" replace />;
  if (needsTenantAssignment) return <Navigate to="/onboarding" replace />;
  if (!tenant) return <Navigate to="/login" replace />;
  return <>{children}</>;
}

export function App() {
  return (
    <Routes>
      <Route path="/login" element={<LoginPage />} />
      <Route path="/signup" element={<SignUpPage />} />
      <Route path="/confirm" element={<ConfirmSignUpPage />} />
      <Route path="/no-tenant" element={<NoTenantPage />} />
      <Route path="/onboarding" element={<OnboardingPage />} />
      <Route
        path="/"
        element={
          <RequireTenant>
            <Layout />
          </RequireTenant>
        }
      >
        <Route index element={<DashboardPage />} />
        <Route path="packages" element={<PackagesPage />} />
        <Route path="routers" element={<RoutersPage />} />
        <Route path="vouchers" element={<VouchersPage />} />
        <Route path="settings" element={<SettingsPage />} />
      </Route>
      <Route path="*" element={<Navigate to="/" replace />} />
    </Routes>
  );
}
